"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitLookup = void 0;
const units_1 = __importDefault(require("./units"));
function createCaseInsensitiveMap(units) {
    const newUnits = Object.keys(units).reduce((soFar, current) => {
        const lower = current.toLowerCase();
        soFar[lower] = units_1.default[current];
        soFar[current] = units_1.default[current];
        return soFar;
    }, {});
    return newUnits;
}
const caseInsensitiveMap = createCaseInsensitiveMap(units_1.default);
const unitLookup = unitString => (unitString &&
    caseInsensitiveMap[unitString.toLowerCase()]) ||
    undefined;
exports.unitLookup = unitLookup;
//# sourceMappingURL=unit-lookup.js.map